/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum NewProposalReason {
  'Update for Usage' = 0,
  'Increase System Size' = 1,
  'Decrease System Size' = 2,
  'Adjust Layout' = 3,
  Other = 4,
  'Timberline Solar Redesign' = 5,
}
